const S3_URI = 'https://festivaldorio.s3.us-east-1.amazonaws.com';

export default S3_URI;
